<template>
    <v-col cols="12">
        <v-card>
            <v-toolbar flat dense color="white lighten-2">
                <v-toolbar-title>Kolejne zadania</v-toolbar-title>
            </v-toolbar>

            <v-divider />

            <v-container fluid class="pa-0">
                <v-row>
                    <v-col cols="12">
                        <PrintingTasksTable v-if="isPrinting" :tasks="nextScheduledTasks" :loading="nextScheduledTasksLoading" />
                        <NonPrintingTasksTable v-else :tasks="nextScheduledTasks" :loading="nextScheduledTasksLoading" />
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-col>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'
import PrintingTasksTable from './PrintingTasksTable.vue'
import NonPrintingTasksTable from './NonPrintingTasksTable.vue'

export default {
    name: 'NextScheduledTasks',
    components: {
        PrintingTasksTable,
        NonPrintingTasksTable
    },
    mixins: [
        dateFormatter,
        parse,
        tooltipDelay
    ],
    props: {
        limit: {
            type: Number,
            default: 1
        },
        isPrinting: {
            type: Boolean,
        }
    },
    data() {
        return {
            nextScheduledTasksLoading: false,
            nextScheduledTasks: []
        }
    },
    computed: {
        workspaceSettings() {
            const workspace = localStorage.getItem('workspace')

            return JSON.parse(workspace)
        }
    },
    mounted() {
        this.getScheduledTasks()
    },
    methods: {
        getScheduledTasks() {
            this.nextScheduledTasksLoading = true
            this.$store.dispatch('reports/getScheduledTasks', {
                machineCode: this.workspaceSettings.machineCode,
                limit: this.limit
            }).then(response => {
                this.nextScheduledTasks = response.data.results
            }).catch(error => {
                throw error
            }).finally(() => {
                this.nextScheduledTasksLoading = false
            })
        }
    }
}
</script>